export default __webpack_public_path__ + "static/SigmarOne-Regular-2a5e0e478128b5b20f75cb87ff4f9334.ttf";